// extracted by mini-css-extract-plugin
module.exports = {"spacer":"styles_spacer__2BgI4","divider":"styles_divider__3e_Zy"};